<template>
  <section id="login" class="col-lg-12 col-sm-12 pt-3 bg-white">

    <form v-on:submit.prevent="login()">
      <div v-if="error" class="alert alert-danger" v-model="error">{{ error }}</div>
      <div class="form-group">
        <input type="text" name="org_id" class="form-control" id="org_id" v-model="input.org_id" placeholder="Org ID">
      </div>
      <div class="form-group">
        <input type="text" name="username" class="form-control" id="username" v-model="input.username"
               placeholder="Username">
      </div>
      <div class="form-group">
        <input type="password" class="form-control" id="password" name="password" v-model="input.password"
               placeholder="Password">
      </div>
      <button type="submit" class="login-btn btn btn-primary col-12" role="submit">
        Login
      </button>
      <p class="mt-4 mb-0 small text-muted text-center">If your company doesn't have a subscription<br><a v-bind:href="this.$company.urlSignup">click
        here</a></p>
    </form>
  </section>
</template>

<script>
import axios from 'axios';
import {sha256} from "js-sha256";

export default {
  name: 'Login',
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      error: null,
      user: null
    }
  },
  methods: {
    login() {

      let self = this;
      if (this.input.username != "" && this.input.password != "") {
        let formData = new FormData();
        formData.append('org_id', this.input.org_id);
        formData.append('username', this.input.username);
        formData.append('password', this.input.password);

        axios.post("/api/user/authorise", formData).then(response => {

          if (
            response.status === 200 &&
            response.data.success === 'true' &&
            response.data.id !== undefined &&
            response.data.id !== '' &&
            response.data.API_KEY !== undefined &&
            response.data.API_KEY !== ''
          ) {
            self.$session.start();
            self.$session.set('token', response.data.token);
            self.$session.set('API_KEY', response.data.API_KEY);
            self.$session.set('id', response.data.id);
            self.$session.set('org_id', response.data.org_id);
            self.user = response.data;

            this.$authenticated = true;
            this.$emit("user", self.user);
            this.$router.replace({name: "Home"});

          } else {
            self.error = "The username and / or password is incorrect";
            this.$router.replace({name: "Login"});
          }

        }).catch(function (error) {
          self.error = error;
          this.$router.replace({name: "Login"});
        });
      } else {
        this.error = "Please enter both username and password";
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue